import { useMemo } from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

import { Box, Flex } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Link } from '~/components/link';
import { useBaseUrl } from '~/hooks/use-base-url';
import { useCatalogPath } from '~/hooks/use-catalog-path';

import { getNavigationData } from '../data';

import { Legal } from './legal';
import { Navigation } from './navigation';
import { NewsletterSignUp } from './newsletter';
import { SocialMedia } from './social-media';

export function PageFooter() {
  const baseUrl = useBaseUrl();
  const { t } = useTranslation();
  const catalogPath = useCatalogPath();
  const navigationData = useMemo(() => getNavigationData(t, catalogPath), [t, catalogPath]);

  return (
    <Box bgColor='white' borderTop='solid 1px' borderTopColor='gray.300'>
      <ContentContainer>
        {/*
          When the fixed "Enroll Now" bar is at the bottom of course/program pages, use its
          measured height as the footer's bottom padding so the links clear it, plus 16px of
          breathing room. The --mobile-sticky-banner-offset var is published by whichever banner is
          visible (price-card.tsx or ab_plp_redesign_2025/mobile-sticky-banner.tsx) and falls back
          to 48px on desktop or when no banner is rendered, so the +16px keeps the default at 64px
          (CONENG-2334).
        */}
        <Box as='footer' pb='calc(var(--mobile-sticky-banner-offset, 48px) + 16px)' pt='64px'>
          <Link aria-label='Link to home page' display='flex' href={baseUrl} locale={false} width='fit-content'>
            <Image alt='Udacity Accenture logo' height={32} src='/images/udacity-accenture-logo.svg' width={170} />
          </Link>

          <Box h={{ base: '24px', xl: '40px' }} />

          <Navigation navigation={navigationData} />

          <Box h='40px' />

          <Flex
            alignItems={{ base: 'flex-start', md: 'flex-end' }}
            flexDirection={{ base: 'column', md: 'row' }}
            gap={{ base: '40px', md: '16px' }}
            justifyContent='space-between'
          >
            <NewsletterSignUp />
            <SocialMedia />
          </Flex>
          {/* <CollapsableNavigation /> */}
          <Legal />
        </Box>
      </ContentContainer>
    </Box>
  );
}
